import { useQuery } from "@tanstack/react-query";
import { chatApi } from "../../api/chat";

export const useGetPinnedMessages = (roomId: string) => {
  return useQuery({
    queryKey: ["pinned-messages", roomId],
    queryFn: () =>
      chatApi.getPinnedMessages({
        roomId,
        keyword: "",
        pageIndex: 1,
        pageSize: 50,
      }),
    enabled: !!roomId,
    refetchOnMount: true,
  });
};

export const useGetPinnedMessageIds = (roomId: string) => {
  return useQuery({
    queryKey: ["pinned-message-ids", roomId],
    queryFn: () => chatApi.getPinnedMessageIds(roomId),
    enabled: !!roomId,
  });
};
